module.exports = __webpack_public_path__ + "img/right-arrow-nav-bar.0d205c79.svg";